var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.relationsNetworkClassNames },
    [
      _vm.showTooltip
        ? _c("tooltipBlock", {
            attrs: {
              loading: _vm.tooltipLoading,
              indexData: _vm.tooltipData,
              closeToolTip: _vm.closeToolTip,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.nodes && _vm.nodes.length && _vm.showRelationsNetworkMenu
        ? _c("relationsNetworkMenu", {
            attrs: {
              downloadImage: _vm.downloadImage,
              toggleFullScreen: _vm.toggleFullScreen,
              printImage: _vm.printImage,
              fullscreen: _vm.fullscreen,
              resetDefault: _vm.resetDefault,
              showRelationsAsList: _vm.showRelationsAsList,
              toggleLegend: _vm.toggleLegend,
              showLegend: _vm.showLegend,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAfilListModal
        ? _c(
            "modal",
            {
              attrs: {
                close: function () {
                  this$1.showAfilListModal = false
                },
                printButton: true,
                downloadButton: true,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "modalHeader" }, slot: "modalHeader" },
                [_vm._v(_vm._s(_vm.printAndDownloadHeaderText))]
              ),
              _vm._v(" "),
              _c(
                "modalBody",
                { attrs: { slot: "modalBody" }, slot: "modalBody" },
                [
                  _vm.relations && _vm.relations.length
                    ? _c(
                        "div",
                        _vm._l(_vm.relations, function (e, i) {
                          return _c("p", { key: i }, [
                            _c("b", [_vm._v("ЮЛ / ФЛ " + _vm._s(i + 1) + ":")]),
                            _vm._v(" "),
                            e && e.names && e.names.length && e.names[0].name
                              ? _c("span", [_vm._v(_vm._s(e.names[0].name))])
                              : _vm._e(),
                            _vm._v(" "),
                            e && e.inn
                              ? _c("span", [
                                  _vm._v("(ИНН: " + _vm._s(e.inn) + ")"),
                                ])
                              : _vm._e(),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("afilModalListImg", {
                    attrs: { src: _vm.canvasImgDataUrl(), alt: "Связи Афил" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.afilAsList, function (e, i) {
                    return _c(
                      "afilModalListItem",
                      {
                        key: i,
                        staticClass: "affiliantion-modal-list",
                        style: {
                          marginLeft:
                            (e.level ? 5 + 40 * (e.level - 1) : 5) + "px",
                          backgroundColor: i % 2 ? "#dedede" : "#fff",
                        },
                      },
                      [
                        e.level
                          ? _c(
                              "afilModalListItemRow",
                              { staticStyle: { float: "right" } },
                              [_c("b", [_vm._v("Уровень " + _vm._s(e.level))])]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "afilModalListItemRow",
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#aaa",
                                  "font-weight": "500",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(i + 1) +
                                    ".\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            e.tooltipData && e.tooltipData.ogrn
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "/company/" + e.tooltipData.ogrn,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        e.tooltipData.name_short
                                          ? e.tooltipData.name_short
                                          : e.tooltipData.name_full
                                      )
                                    ),
                                  ]
                                )
                              : e.tooltipDat && e.tooltipData.inn
                              ? _c(
                                  "person-afil",
                                  {
                                    staticStyle: { display: "inline-block" },
                                    attrs: {
                                      inn: e.tooltipData.inn,
                                      fio: e.tooltipData.title,
                                    },
                                  },
                                  [_vm._v(_vm._s(e.tooltipData.title))]
                                )
                              : e.label && e.inn
                              ? _c(
                                  "person-afil",
                                  {
                                    staticStyle: { display: "inline-block" },
                                    attrs: { inn: e.inn, fio: e.label },
                                  },
                                  [_vm._v(_vm._s(e.label))]
                                )
                              : e.tooltipData
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      e.tooltipData.name_short
                                        ? e.tooltipData.name_short
                                        : e.tooltipData.name_full
                                    )
                                  ),
                                ])
                              : e.label
                              ? _c("b", [_vm._v(_vm._s(e.label))])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        e.inn || e.ogrn
                          ? _c("afilModalListItemRow", [
                              e.inn ? _c("b", [_vm._v("ИНН: ")]) : _vm._e(),
                              _vm._v(" "),
                              e.inn
                                ? _c("span", [_vm._v(_vm._s(e.inn))])
                                : _vm._e(),
                              _vm._v(" "),
                              e.ogrn ? _c("b", [_vm._v("ОГРН: ")]) : _vm._e(),
                              _vm._v(" "),
                              e.ogrn
                                ? _c("span", [_vm._v(_vm._s(e.ogrn))])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData &&
                        (e.tooltipData.date_start || e.tooltipData.date_stop)
                          ? _c("afilModalListItemRow", [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getStatusIcon(e.tooltipData.status_type)
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticStyle: {
                                    "padding-left": "2px",
                                    "font-style": "italic",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.statusTypeText(
                                          e.tooltipData.status_type
                                        )
                                      ) +
                                      "\n                        " +
                                      _vm._s(
                                        e.tooltipData.date_stop
                                          ? new Date(
                                              e.tooltipData.date_stop
                                            ).toLocaleDateString("ru")
                                          : new Date(
                                              e.tooltipData.date_start
                                            ).toLocaleDateString("ru")
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData && e.tooltipData.addr_full
                          ? _c("afilModalListItemRow", [
                              _c("b", [_vm._v("Адрес: ")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(e.tooltipData.addr_full)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData &&
                        e.tooltipData.upr &&
                        e.tooltipData.upr.length
                          ? _c(
                              "afilModalListItemRow",
                              [
                                e.tooltipData.upr[0].position
                                  ? _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.lowerButFirst(
                                            e.tooltipData.upr[0].position
                                          )
                                        ) + ": "
                                      ),
                                    ])
                                  : _c("b", [_vm._v("Руководитель: ")]),
                                _vm._v(" "),
                                e.tooltipData.upr[0].ogrn
                                  ? _c(
                                      "cardLink",
                                      {
                                        attrs: {
                                          ogrn: e.tooltipData.upr[0].ogrn,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(e.tooltipData.upr[0].name)
                                        ),
                                      ]
                                    )
                                  : e.tooltipData.upr[0].inn
                                  ? _c(
                                      "person-afil",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                        attrs: {
                                          inn: e.tooltipData.upr[0].inn,
                                          fio: e.tooltipData.upr[0].name,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(e.tooltipData.upr[0].name)
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(e.tooltipData.upr[0].name)),
                                    ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData &&
                        e.tooltipData.uchr &&
                        e.tooltipData.uchr.length
                          ? _c(
                              "afilModalListItemRow",
                              [
                                _c("b", [_vm._v("Собственники: ")]),
                                _vm._v(" "),
                                _vm._l(
                                  e.tooltipData.uchr.filter(function (e, i) {
                                    return i < 5
                                  }),
                                  function (uchrElm, uchrIndex) {
                                    return _c(
                                      "span",
                                      { key: uchrIndex },
                                      [
                                        uchrElm.ogrn
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "/company/" + uchrElm.ogrn,
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v(_vm._s(uchrElm.name))]
                                            )
                                          : uchrElm.inn
                                          ? _c("person-afil", {
                                              staticStyle: {
                                                display: "inline-block",
                                              },
                                              attrs: {
                                                inn: uchrElm.inn,
                                                fio: uchrElm.name,
                                              },
                                            })
                                          : _c("span", [
                                              _vm._v(_vm._s(uchrElm.name)),
                                            ]),
                                        _vm._v(" "),
                                        uchrIndex !=
                                        e.tooltipData.uchr.filter(function (
                                          e,
                                          i
                                        ) {
                                          return i < 5
                                        }).length -
                                          1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "-2px",
                                                },
                                              },
                                              [_vm._v(", ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData && e.tooltipData.okved_title
                          ? _c("afilModalListItemRow", [
                              _c("b", [_vm._v("ОКВЭД: ")]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(e.tooltipData.okved_title) +
                                  "\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData && e.tooltipData.auth_capital
                          ? _c("afilModalListItemRow", [
                              _c("b", [_vm._v("Уставный капитал: ")]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.moneyFormat(e.tooltipData.auth_capital)
                                  ) +
                                  " руб.\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.tooltipData &&
                        e.tooltipData.fin_years &&
                        e.tooltipData.fin_rations &&
                        e.tooltipData.fin_rations.viruchka &&
                        e.tooltipData.fin_years.length
                          ? _c("afilModalListItemRow", [
                              _c("b", [
                                _vm._v(
                                  "Выручка за " +
                                    _vm._s(
                                      e.tooltipData.fin_years[
                                        e.tooltipData.fin_years.length - 1
                                      ]
                                    ) +
                                    " год:"
                                ),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.moneyFormat(
                                      e.tooltipData.fin_rations.viruchka
                                    )
                                  ) +
                                  " руб.\n                "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        ref: "relations-search-scheme",
        attrs: { id: "relations-search-scheme" },
      }),
      _vm._v(" "),
      _vm.nodes && _vm.nodes.length && _vm.showLegend
        ? _c("relationsLegend", {
            class: { fullscreen: _vm.fullscreen },
            attrs: {
              legend: _vm.legend,
              toggleLegendRelations: _vm.toggleLegendRelations,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }